import { Extension } from "@tiptap/core";

import TextDropdown from "./components/TextDropdown";

export const TextBubble =
	Extension.create(
	{
		name: "text-bubble",
		addOptions() {
			return {
				...this.parent?.(),
				toolbar: false,
				button: () => ({
					component: TextDropdown,
					componentProps: {}
				})
			};
		}
	});

export default TextBubble;
